export default __webpack_public_path__ + "static/no-generic-c6489e6847c646f21d92d865b4af07de.png";